module.exports = __webpack_public_path__ + "img/windy.770c3d16.svg";